//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action$Type } from '../genericFlowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    resultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    vendors: [],
    vendorsLoaded: false,
}

//In use : actionTypes.PHOBOS_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}
//In use : actionTypes.
const invoiceSubmittedError = (state:ReducerState$Type,action:Action$Type) => {
    return {
        ...state,
        error: action.error
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const editVerifyFormDataError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

const updateFormError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const refreshedLetoVendors=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        vendors: action.vendors,
        vendorsLoaded: true
    }
}

const refreshedErosVendorsError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.PHOBOS_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.PHOBOS_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.PHOBOS_INV_SUBMIT_ERROR]: invoiceSubmittedError,
    [actionTypes.PHOBOS_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.PHOBOS_EDIT_VERIFY_FORM_DATA_ERROR]: editVerifyFormDataError,
    [actionTypes.PHOBOS_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_PHOBOS_VENDORS_SUCCESS]: refreshedLetoVendors,
    [actionTypes.REFRESH_PHOBOS_VENDORS_ERROR]: refreshedErosVendorsError
});


// WEBPACK FOOTER //
// ./src/redux/phobos/reducer.js